/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		31: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["loftWebpackJsonp"] = window["loftWebpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([61,0]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/scripts/vendors/sections/flickity.js
var flickity = __webpack_require__(2);
var flickity_default = /*#__PURE__*/__webpack_require__.n(flickity);

// EXTERNAL MODULE: ./src/scripts/vendors/global/events.js
var events = __webpack_require__(1);

// EXTERNAL MODULE: ./src/scripts/features/global-video.js
var global_video = __webpack_require__(7);

// CONCATENATED MODULE: ./src/scripts/sections/home-slideshow.js



var LoftSiteVideo = Object(global_video["a" /* default */])();
theme.Site = theme.Site || {};
var _selectors = {
  theme: {
    slideshowContainer: '.slideshow__container',
    slideshowSlide: '.slideshow__slide',
    slideshowButtonWrapper: '.slideshow__button-wrapper'
  },
  plugin: {
    dots: '.flickity-page-dots'
  }
};

var slideshowInit = function slideshowInit(container) {
  var sectionContainer = container;
  var slideshow = home_slideshow_slideshowFactory(sectionContainer);
  return slideshow;
}; // Basic factory recipe


var home_slideshow_slideshowFactory = function slideshowFactory(sectionContainer) {
  // Setup the prototype
  var slideshowPrototype = {
    init: function init() {
      this._initVideos();

      this._getActiveElements();

      this._adjustControls();

      this._adjustColors();

      this._setupEventListeners(this.slider);
    },
    _setupEventListeners: function _setupEventListeners() {
      this.slider.on('change', function (index) {
        this._getActiveElements();

        this._adjustControls();

        this._adjustColors();
      }.bind(this));

      window.onresize = function () {
        this._adjustControls();

        this._adjustColors();

        this.slider.viewport.style.height = "";
        this.slider.resize();
      }.bind(this);
    },
    _initVideos: function _initVideos() {
      this.videos = this.slider.element.querySelectorAll('[data-section-element="video"]');

      if (this.videos.length < 1) {
        return;
      }

      this.videos.forEach(function (videoSlide) {
        var videoContainerId = videoSlide.getAttribute('data-section-id');
        var youtubeVideo = videoSlide.querySelector('[data-youtube]');
        LoftSiteVideo.init(videoSlide, videoContainerId);
      });
    },
    _getActiveElements: function _getActiveElements() {
      var dots = this.slider.element.querySelectorAll('.dot') || '';
      var dotsList = [].slice.call(dots);
      this.activeElements = {
        dots: this.slider.element.querySelectorAll('.dot') || '',
        dotWrapper: this.slider.selectedElement.querySelector('.slideshow__dot-wrapper') || '',
        dotContainerDefault: this.slider.element.querySelector('.flickity-page-dots') || this.slider.selectedElement.querySelector('.flickity-page-dots'),
        slideshowText: this.slider.selectedElement.querySelector('.slideshow__text') || '',
        slideshowWidth: this.slider.selectedElement.querySelector('.slideshow__text').offsetWidth || '',
        textHeight: this.slider.selectedElement.querySelector('.slideshow__text').offsetHeight + 'px' || false,
        buttonWrapper: this.slider.selectedElement.querySelector('.slideshow__button-wrapper') || '',
        previousButton: this.slider.element.querySelector('.flickity-prev-next-button.previous') || '',
        nextButton: this.slider.element.querySelector('.flickity-prev-next-button.next') || '',
        colorMobile: this.slider.selectedElement.getAttribute('data-colors-mobile') || '',
        colorDesktop: this.slider.selectedElement.getAttribute('data-colors-desktop') || ''
      };
    },
    _adjustControls: function _adjustControls() {
      if (this.slider.slides.length < 2) {
        return;
      }

      this.activeElements.dotWrapper.appendChild(this.activeElements.dotContainerDefault);
      this.activeElements.buttonWrapper.appendChild(this.activeElements.previousButton);
      this.activeElements.buttonWrapper.appendChild(this.activeElements.nextButton);
      this.activeElements.dotContainerDefault.style.display = 'block';
      this.activeElements.buttonWrapper.style.height = this.activeElements.textHeight;
      return;
    },
    _adjustColors: function _adjustColors() {
      if (window.innerWidth > 768) {
        this.activeElements.dots.forEach(function (item) {
          item.style.background = this.activeElements.colorDesktop;
        }.bind(this));
        this.activeElements.previousButton.style.color = this.activeElements.colorDesktop;
        this.activeElements.nextButton.style.color = this.activeElements.colorDesktop;
      } else {
        this.activeElements.dots.forEach(function (item) {
          item.style.background = this.activeElements.colorMobile;
        }.bind(this));
        this.activeElements.previousButton.style.color = this.activeElements.colorMobile;
        this.activeElements.nextButton.style.color = this.activeElements.colorMobile;
      }

      return;
    }
  }; // Create the instance

  return function () {
    var section = sectionContainer || '';
    var slideshow = Object.create(slideshowPrototype);
    slideshow.section = section || '';
    slideshow.sliderContainer = slideshow.section.querySelector(_selectors.theme.slideshowContainer);
    slideshow.eventHandlers = {};
    slideshow.slides = slideshow.sliderContainer.querySelectorAll(_selectors.theme.slideshowSlide);
    slideshow.settings = {
      autoPlay: parseInt(slideshow.sliderContainer.getAttribute('data-autoplay'))
    };
    slideshow.activeElements = {};
    slideshow.slides.forEach(function (slide) {
      slide.classList.remove('is-hidden');
      slide.offsetHeight;
    });
    slideshow.slider = new flickity_default.a(slideshow.sliderContainer, {
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 75,
        y2: 35,
        x3: 40
      },
      cellAlign: "left",
      lazyLoad: false,
      freeScroll: false,
      groupCells: "100%",
      imagesLoaded: true,
      pageDots: true,
      contain: true,
      resize: true,
      autoPlay: slideshow.settings.autoPlay
    });
    return slideshow;
  }();
};

function Slideshow(container) {
  this.container = container;
  this.slider = slideshowInit(this.container);
  this.slider.init();
}
Slideshow.prototype = {};
// CONCATENATED MODULE: ./src/scripts/build/slideshow.js

var slideshow_slider = {
  runSlider: function runSlider(container) {
    var slider = new Slideshow(container);
  }
};
window.theme = window.theme || {};
window.theme.scripts = window.theme.scripts || {};
window.theme.scripts.slideshow = window.theme.scripts.slideshow || {};
window.theme.scripts.slideshow.init = slideshow_slider.runSlider;

/***/ })

/******/ });